import { Alert } from "@/components/alert";
import { useModal } from "@/contexts";
import { MEDIA } from "@/styles/common";
import { Center, Flex, Text } from "@chakra-ui/react";
import { useCountPerson } from "../../hooks";
import { CustomButton, CustomText } from "./personCount.style";
import { type PersonCountProps } from "./personCount.type";

export const PersonCount = ({ addFee, addPerson, personOfCapacity, ...rest }: PersonCountProps) => {
    const { handleCountPerson, personCountMap } = useCountPerson({
        ...personOfCapacity,
        ...addFee,
        ...rest,
    });
    const { isTablet, isMobile } = MEDIA();
    const { openModal, setModalContent, setIconName } = useModal();

    const handleMaxPerson = (e: React.MouseEvent<HTMLButtonElement>) => {
        const { currentTarget } = e;
        const isIncrement = currentTarget?.textContent === "+";
        const totalCount = personCountMap[0] + personCountMap[1] + personCountMap[2];

        if (isIncrement && totalCount === Number(personOfCapacity.max)) {
            openModal();
            setModalContent(<Alert>기준 최대인원 {personOfCapacity.max}인을 초과할 수 없습니다.</Alert>);
            if (!isMobile) setIconName("close");
        }
    };

    return (
        <Center w="100%" flexDir="column" rowGap="8px" alignItems="flex-start">
            {addPerson.map((person, idx) => {
                const { [idx as 0 | 1 | 2]: currentState } = personCountMap;
                const { ageRange, type } = person;

                return (
                    <Center
                        key={type}
                        columnGap="16px"
                        w="100%"
                        justifyContent={isTablet ? "space-between" : "initial"}
                    >
                        <Flex w="128px" justifyContent="flex-start" flexDir="column" flexShrink={0}>
                            <CustomText fontSize="16px">{type}</CustomText>
                            <Text fontSize="12px" fontWeight="300">
                                {ageRange && ageRange?.max > 0 ? `${ageRange.min}세 이상 ~ ${ageRange.max}세 이하` : ""}
                            </Text>
                        </Flex>
                        <Center>
                            <CustomButton round="full" onClick={(e) => handleCountPerson(e, idx, currentState)}>
                                -
                            </CustomButton>
                            <Center flexShrink={0} w="36px" h="36px">
                                {currentState}
                            </Center>
                            <CustomButton
                                round="full"
                                onClick={(e) => {
                                    handleCountPerson(e, idx, currentState);
                                    handleMaxPerson(e);
                                }}
                            >
                                +
                            </CustomButton>
                        </Center>
                    </Center>
                );
            })}
        </Center>
    );
};
